<template>

  <div id="offCanvas3" class="off-canvas off-canvas-right wd-600">

    <div id="scroll1" class="pd-20 ht-100p tx-13 gwas-elevation pos-relative">
      <div class="pd-y-10">
        <h3 class="tx-bold tx-spacing--2 tx-brand-02 mg-b-0">har<span class="tx-normal tx-primary">Vest</span></h3>
        <span class="tx-sans tx-9 tx-uppercase tx-semibold tx-spacing-1 tx-color-03">Create New Contact</span>
      </div>

      <a href="" role="button" class="close pos-absolute t-15 r-15" aria-label="Close">
        <span aria-hidden="true"> <i data-feather="x"></i> </span>
      </a>

      <!--      <h5 class="tx-18 tx-sm-20 mg-b-20">Create New Contact</h5>-->
      <!--      <p class="tx-13 tx-color-03 mg-b-30">You can add more information than what you see here, such as address and-->
      <!--        birthday by clicking <span class="tx-color-02">Add More Fields</span> button below to bring up more options.-->
      <!--      </p>-->

      <div class="d-sm-flex">
        <div class="flex-fill">

          <!--          <div class="row no-gutters pd-t-20 bd-t">-->
          <!--            <div class="col-sm">-->
          <!--              <div class="form-group">-->
          <!--                <label class="tx-sans tx-10 tx-uppercase tx-bold tx-spacing-1 tx-color-02 mg-b-10">Firstname</label>-->
          <!--                <input v-model="state.first_name" type="text" class="form-control"-->
          <!--                       placeholder="Enter firstname">-->
          <!--                <label v-if="v$.first_name.$error" class="tx-danger">{{ v$.first_name.$errors[0].$message }}</label>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->

          <div class="row pd-t-20 bd-t">
            <label class="tx-sans tx-10 tx-uppercase tx-bold tx-spacing-1 tx-color-02 mg-b-10">Firstname, Middlename and
              Lastname</label>

            <div class="input-group">
              <input v-model="state.first_name" type="text" class="form-control" placeholder="Enter firstname">
              <input v-model="state.middle_name" type="text" class="form-control" placeholder="Enter middlename">
              <input v-model="state.last_name" type="text" class="form-control" placeholder="Enter lastname">
            </div>

            <div class="input-group">
              <div class="col-sm">
                <div v-if="v$.first_name.$error" class="tx-danger mg-t-5">{{ v$.first_name.$errors[0].$message }}</div>
              </div>
              <div class="col-sm">
                <div v-if="v$.middle_name.$error" class="tx-danger mg-t-5">{{ v$.middle_name.$errors[0].$message }}
                </div>
              </div>
              <div class="col-sm">
                <div v-if="v$.last_name.$error" class="tx-danger mg-t-5">{{ v$.last_name.$errors[0].$message }}</div>
              </div>
            </div>
          </div>

          <div class="row pd-t-20">
            <label class="tx-sans tx-10 tx-uppercase tx-bold tx-spacing-1 tx-color-02 mg-b-10">Email and Phone
              Number</label>

            <div class="input-group">
              <input v-model="state.email" type="text" class="form-control" placeholder="Enter email">
              <input v-model="state.phone_number" type="text" class="form-control" placeholder="Enter phone Number">
            </div>

            <div class="input-group">
              <div class="col-sm"><label v-if="v$.email.$error" class="tx-danger mg-t-5">{{
                  v$.email.$errors[0].$message
                }}</label></div>
              <div class="col-sm"><label v-if="v$.phone_number.$error"
                                         class="tx-danger mg-t-5">{{ v$.phone_number.$errors[0].$message }}</label>
              </div>
            </div>


          </div>

          <div class="row pd-t-20">
            <label class="tx-sans tx-10 tx-uppercase tx-bold tx-spacing-1 tx-color-02 mg-b-10">Contact Address and
              County
            </label>
            <div class="input-group">
              <input v-model="state.contact_address" type="text" class="form-control"
                     placeholder="Enter contact Address">
              <input v-model="state.county" type="text" class="form-control" placeholder="Enter County">
            </div>

            <label v-if="v$.contact_address.$error" class="tx-danger">{{
                v$.contact_address.$errors[0].$message
              }}</label>
            <label v-if="v$.county.$error" class="tx-danger">{{ v$.county.$errors[0].$message }}</label>

          </div>


          <div class="row pd-t-20">
            <label class="tx-sans tx-10 tx-uppercase tx-bold tx-spacing-1 tx-color-02 mg-b-10"> Town / City and
              PostCode</label>
            <div class="input-group">
              <input v-model="state.town_city" type="text" class="form-control" placeholder="Enter Town / City">
              <input v-model="state.post_code" type="text" class="form-control" placeholder="Enter Post Code">
            </div>
            <label v-if="v$.town_city.$error" class="tx-danger">{{ v$.town_city.$errors[0].$message }}</label>
            <label v-if="v$.post_code.$error" class="tx-danger">{{ v$.post_code.$errors[0].$message }}</label>
          </div>


          <div class="row pd-t-20">
            <label class="tx-sans tx-10 tx-uppercase tx-bold tx-spacing-1 tx-color-02 mg-b-10"> Birthday Month and
              Day</label>
            <div class="input-group">
              <select v-model="state.birthday_month" class="form-control" style="width: 10px; border-radius: 0;">
                <option label="Choose Month of Birth"></option>
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </select>

              <select v-model="state.birthday_day" class="form-control" style="width: 10px; border-radius: 0;">
                <option label="Enter Birthday Day"></option>
                <option v-for="i in 31" :key="i">{{ i }}</option>
              </select>
            </div>
            <label v-if="v$.birthday_day.$error" class="tx-danger">{{ v$.birthday_day.$errors[0].$message }}</label>
            <label v-if="v$.birthday_month.$error" class="tx-danger">{{ v$.birthday_month.$errors[0].$message }}</label>
          </div>


          <div class="row pd-t-20">
            <label class="tx-sans tx-10 tx-uppercase tx-bold tx-spacing-1 tx-color-02 mg-b-10"> Marital Status and
              Gender</label>
            <div class="input-group">

              <select v-model="state.marital_status" class="form-control select2-no-search">
                <option label="Choose Marital Status"></option>
                <option value="married">Married</option>
                <option value="single">Single</option>
                <option value="separated">Separated</option>
                <option value="divorced">Divorced</option>
                <option value="widowed">Widowed</option>
              </select>

              <select v-model="state.gender" class="form-control select2-no-search">
                <option label="Choose Gender"></option>
                <option value="MALE">MALE</option>
                <option value="FEMALE">FEMALE</option>
              </select>
            </div>
            <label v-if="v$.marital_status.$error" class="tx-danger">{{ v$.marital_status.$errors[0].$message }}</label>
            <label v-if="v$.gender.$error" class="tx-danger">{{ v$.gender.$errors[0].$message }}</label>
          </div>


          <div class="row pd-t-20">
            <label class="tx-sans tx-10 tx-uppercase tx-bold tx-spacing-1 tx-color-02 mg-b-10"> BFC / WOFBI / Water
              Baptism / Service Unit </label>
            <div class="input-group">

              <select v-model="state.bfc_status" class="form-control select2-no-search">
                <option label="Has Done Foundation Class?"></option>
                <option value="YES">YES</option>
                <option value="NO">NO</option>
              </select>

              <select v-model="state.wofbi_status" class="form-control select2-no-search">
                <option label="Has Done WOFBI?"></option>
                <option value="YES">YES</option>
                <option value="NO">NO</option>
              </select>

              <select v-model="state.water_baptism" class="form-control select2-no-search">
                <option label="IS BAPTISED WITH WATER?"></option>
                <option value="YES">YES</option>
                <option value="NO">NO</option>
              </select>

            </div>
            <label v-if="v$.bfc_status.$error" class="tx-danger">{{
                v$.bfc_status.$errors[0].$message
              }}</label>
            <label v-if="v$.wofbi_status.$error" class="tx-danger">{{
                v$.wofbi_status.$errors[0].$message
              }}</label>
            <label v-if="v$.water_baptism.$error" class="tx-danger">{{
                v$.water_baptism.$errors[0].$message
              }}</label>
          </div>


          <div class="row pd-y-20">
            <label class="tx-sans tx-10 tx-uppercase tx-bold tx-spacing-1 tx-color-02 mg-b-10"> First Attendance /
              Service eUnit </label>
            <div class="input-group">

              <input v-model="state.first_attendance" type="text" class="form-control" onfocus="(this.type='date')"
                     onblur="(this.type='text')" placeholder="Enter first attendance day"/>

              <select v-model="state.service_unit" class="form-control select2-no-search">
                <option label="CHOOSE SERVICE UNIT"></option>
                <option value="Technical">Technical</option>
                <option value="Ushering">Ushering</option>
                <option value="Finance">Finance</option>
                <option value="Sanctuary">Sanctuary Keepers</option>
                <option value="Altar Minister">Altar Minister</option>
                <option value="Children Uni">Children Unit</option>
                <option value="yaf">Youth Alive Exco</option>
              </select>

            </div>

            <label v-if="v$.first_attendance.$error" class="tx-danger">{{
                v$.first_attendance.$errors[0].$message
              }}</label>
            <label v-if="v$.service_unit.$error" class="tx-danger">{{
                v$.service_unit.$errors[0].$message
              }}</label>
          </div>


        </div>
      </div>
      <label v-if="formError" class="tx-danger">{{ formError }}</label>

      <div class="wd-100p d-flex flex-column flex-sm-row justify-content-end">
        <button v-on:click="validateContactAndSubmit" type="button" class="btn btn-primary mg-b-5 mg-sm-b-0">Save
          Contact
        </button>
        <button href="#" class="btn btn-secondary mg-sm-l-5 close" type="button" style="font-size: 14px;">Discard
        </button>
      </div>

    </div>
  </div><!-- off-canvas -->


  <div class="modal fade effect-scale" id="modalNewContact" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body pd-20 pd-sm-30">
          <a href="" type="button" class="close pos-absolute t-20 r-20 text-secondary close">
            <span aria-hidden="true">&times;</span>
          </a>

        </div>
      </div>
    </div><!-- modal-dialog -->
  </div><!-- modal -->
</template>


<script>
import {computed, reactive} from "vue";
import {email, numeric, required} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import serviceMixin from "@/mixins/contact-service";

export default {
  name: "ContactForm",
  mixins: [serviceMixin],
  setup() {
    const state = reactive({
      first_name: "",
      middle_name: "",
      last_name: "",
      email: "",
      phone_number: "",
      contact_address: "",
      marital_status: "",
      town_city: "",
      county: "Cambridge",
      post_code: "CB1 5RT",
      birthday_month: "5",
      birthday_day: "8",
      gender: "FEMALE",
      first_attendance: "2022-08-22",
      bfc_status: "NO",
      water_baptism: "NO",
      service_unit: "Technical",
      wofbi_status: "NO",
    })
    const rules = computed(() => {
      return {
        first_name: {required},
        middle_name: {required},
        last_name: {required},
        email: {required, email},
        phone_number: {required, numeric},
        contact_address: {required},
        marital_status: {required},
        town_city: {required},
        county: {required},
        post_code: {required},
        birthday_month: {required},
        birthday_day: {required, numeric},
        gender: {required},
        first_attendance: {required},
        bfc_status: {required},
        water_baptism: {required},
        service_unit: {required},
        wofbi_status: {required},
      }
    });
    const v$ = useVuelidate(rules, state)
    return {state, v$}
  },
  methods: {
    async validateContactAndSubmit() {
      this.report = "";
      this.v$.$validate();
      if (this.v$.$error) {
        this.formError = "Please Fix the error in the form"
      } else {
        this.formError = null;
        // this.$refs.closeModalBtn.click();
        this.report = await this.saveContact(this.state).catch(err => {
          return {
            details: err.response.data.errorMessage,
            failed: true
          };
        });
      }
    },

  }
}
</script>

<style scoped>

</style>
